import React, { FunctionComponent } from 'react'
import {
  WbModal,
  WbModalContent,
  WbModalFooter,
  WbModalHeader,
} from '@workbench/react/dist'
import { Button } from 'components'
import { useTranslation } from 'react-i18next'
import { LanguageChange } from './LanguageChange'

interface ModalProps {
  headline: string
}

interface PromptModalProps extends ModalProps {
  confirmCallback: () => void
  confirmText?: string
  cancelCallback?: () => void
  cancelText?: string
  disable?: boolean
}

interface InfoModalProps extends ModalProps {
  onClose: () => void
  showLanguagePicker?: boolean
}

export const InfoModal: FunctionComponent<InfoModalProps> = ({
  headline,
  children,
  onClose,
  showLanguagePicker,
}) => {
  return (
    <WbModal
      mode="info"
      onWbclose={onClose}
      closeOnBackdropClick={true}
      closeOnEscapeKey={true}
    >
      <WbModalHeader>
        {showLanguagePicker ? (
          <div
            style={{
              position: 'absolute',
              left: '2rem',
            }}
          >
            <LanguageChange />{' '}
          </div>
        ) : (
          ''
        )}
      </WbModalHeader>
      <WbModalContent headline={headline}>{children}</WbModalContent>
    </WbModal>
  )
}

export const PromptModal: FunctionComponent<PromptModalProps> = ({
  headline,
  children,
  cancelCallback,
  cancelText,
  confirmCallback,
  confirmText,
  disable,
}) => {
  const { t } = useTranslation()

  return (
    <WbModal mode="prompt">
      <WbModalContent headline={headline}>{children}</WbModalContent>
      <WbModalFooter>
        {cancelCallback && (
          <Button variant="secondary" onClick={cancelCallback}>
            {cancelText || t('components.modal.promptModal.cancel')}
          </Button>
        )}

        <Button
          id="confirm-new-booking-e2e"
          onClick={confirmCallback}
          disabled={disable}
        >
          {confirmText || t('components.modal.promptModal.confirm')}
        </Button>
      </WbModalFooter>
    </WbModal>
  )
}
interface EditModalProps extends ModalProps {
  confirmCallback: () => void
  confirmText?: string
  cancelCallback?: () => void
  cancelText?: string
  onClose?: () => void
}

export const EditModal: FunctionComponent<EditModalProps> = ({
  headline,
  children,
  cancelCallback,
  cancelText,
  confirmCallback,
  confirmText,
  onClose,
}) => {
  const { t } = useTranslation()

  return (
    <WbModal mode="edit" onWbclose={onClose}>
      <WbModalContent headline={headline}>{children}</WbModalContent>
      <WbModalFooter>
        {cancelCallback && (
          <Button variant="secondary" onClick={cancelCallback}>
            {cancelText || t('global.cancel')}
          </Button>
        )}

        <Button onClick={confirmCallback}>
          {confirmText || t('global.confirm')}
        </Button>
      </WbModalFooter>
    </WbModal>
  )
}
